import {Component, EventEmitter, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {LogicalConjunctionService} from '../../../services/common/logical-conjunction/logical-conjunction.service';
import {SearchTermDefinitionInf} from '../../../interfaces/common/search/search-term-definition-inf';
import {UserPrivilegeService} from '../../../services/common/user-privilege/user-privilege.service';

export interface VoIPPeerDialogInf {
  selectedItem: any;
  isEditMode?: boolean;
  cacProfiles: any;
}

@Component({
  selector: 'voip-peers-dialog',
  templateUrl: './voip-peers-dialog.component.html',
  styleUrls: ['./voip-peers-dialog.component.scss']
})
export class VoipPeersDialogComponent implements OnInit {

  constructor(private logicalConjunctionService: LogicalConjunctionService,
              public dialogRef: MatDialogRef<VoipPeersDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: VoIPPeerDialogInf,
              private userPrivilege: UserPrivilegeService) { }

  onApply = new EventEmitter();
  onCancel = new EventEmitter();
  sipHeaderOptions = ['NA', 'IP_PHONES', 'SIP_TRUNK', 'IP_PBX', 'PBX', 'PSTN', 'TEAMS'];
  resourceGroups;
  isAuthorized: boolean;

  ngOnInit(): void {
    this.isAuthorized = this.userPrivilege.isAuthorized();

    if (this.data && this.data.selectedItem && this.data.selectedItem.topologyGroups) {
      this.resourceGroups = this.logicalConjunctionService.generateAndDescription(this.data.selectedItem.topologyGroups, 'name');
    }
  }

  cancel(): void {
    this.dialogRef.close();
    this.onCancel.emit();
  }

  submit(): void {
    this.onApply.emit(this.data);
  }
}
